export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_10089_PERCENTAGE': '%',
    '_10090_NUMBER': '#',
    '_11202_STATE': 'State'
};
